<span [ngClass]="isBoldLabel ? 'text-body-s' : ''">{{ label }} : </span><span class="text-body-xs">{{ value }}</span>
